import { Toaster } from 'sonner'
import { AccessibilityBar } from './components/AccessibilityBar'
import { CookieBanner } from './components/CookieBanner'
import ErrorBoundary from './components/ErrorBoundary'
import { Footer } from './components/Footer'
import { Navbar } from './components/Navbar'
import { AccessibilityProvider } from './contexts/AccessibilityContext'
import { ConsentProvider } from './contexts/ConsentContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { AuthProvider } from './contexts/AuthContext'
import AppRoutes from './AppRoutes'
import { useLocation } from 'wouter'

// Componente separado
function AppContent() {
  // useTokenMonitor() // 👈 REMOVIDO - estava causando loop
  const [location] = useLocation()
  
  // Verifica se está em uma rota administrativa
  const isAdminRoute = location.startsWith('/admin')
  
  return (
    <>
      {/* Só mostra a Navbar se NÃO for rota admin */}
      {!isAdminRoute && <Navbar />}
      
      <main id="conteudo-principal">
        <AppRoutes />
      </main>
      
      {/* Só mostra o Footer se NÃO for rota admin */}
      {!isAdminRoute && <Footer />}
    </>
  )
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="light">
        <AccessibilityProvider>
          <ConsentProvider>
            <AuthProvider>
              <Toaster position="top-center" richColors />
              <a href="#conteudo-principal" className="skip-link">
                Pular para conteúdo principal
              </a>
              <AccessibilityBar />
              <AppContent />
              <CookieBanner />
            </AuthProvider>
          </ConsentProvider>
        </AccessibilityProvider>
      </ThemeProvider>
    </ErrorBoundary>
  )
}

export default App